import { Link } from "react-router-dom";

import Toggle from "../Toggle";

const ChannelPreferanceCard = ({
  title,
  buttonName,
  description,
  isOn,
  onClick,
  id,
  icon,
  last,
}) => {
  return (
    <div
      className={`flex items-center gap-3 px-4 py-3.5 ${
        last ? "" : "border-b border-gray-100"
      }`}
    >
      <span className="w-9 h-9 rounded-full bg-[#664bc7]/10 flex items-center justify-center text-[#664bc7] shrink-0">
        {icon}
      </span>
      <div className="flex-1 min-w-0">
        <h1 className="font-medium text-[#1f2937]">{title}</h1>
        <div className="text-[13px] text-gray-500 mt-0.5 leading-snug">
          {description}
        </div>
        {buttonName && (
          <Link
            to="/myaccount"
            className="inline-block mt-2 text-xs font-semibold text-[#664bc7]"
          >
            {buttonName} ›
          </Link>
        )}
      </div>
      <Toggle isOn={isOn} onClick={onClick} id={id} />
    </div>
  );
};

export default ChannelPreferanceCard;
